import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { className: "page-title" }, "Filters", -1)
const _hoisted_2 = { class: "row q-mt-md" }
const _hoisted_3 = {
  key: 0,
  class: "col-12 q-pb-sm"
}
const _hoisted_4 = {
  key: 1,
  class: "col-12 q-pb-sm"
}
const _hoisted_5 = {
  key: 2,
  class: "col-12 q-pb-sm"
}
const _hoisted_6 = {
  key: 3,
  class: "col-12 q-pb-sm"
}
const _hoisted_7 = {
  key: 4,
  class: "col-12 q-pb-sm"
}
const _hoisted_8 = {
  key: 5,
  class: "col-12 q-pb-sm"
}
const _hoisted_9 = {
  key: 6,
  class: "col-12 q-pb-sm"
}
const _hoisted_10 = {
  key: 7,
  class: "col-12 q-pb-sm"
}
const _hoisted_11 = {
  key: 8,
  class: "col-12 q-pb-sm"
}
const _hoisted_12 = {
  key: 9,
  class: "col-12 q-pb-sm"
}
const _hoisted_13 = {
  key: 10,
  class: "col-12 q-pb-sm"
}
const _hoisted_14 = { class: "full-width row" }
const _hoisted_15 = {
  key: 0,
  class: "q-py-xs col-6"
}
const _hoisted_16 = {
  key: 1,
  class: "q-py-xs col-6"
}
const _hoisted_17 = {
  key: 11,
  class: "q-py-xs col-6"
}
const _hoisted_18 = {
  key: 12,
  class: "q-py-xs col-6"
}
const _hoisted_19 = {
  key: 13,
  class: "q-py-xs col-6"
}
const _hoisted_20 = {
  key: 14,
  class: "col-12 q-pb-sm"
}
const _hoisted_21 = {
  key: 15,
  class: "col-12 q-pb-sm"
}
const _hoisted_22 = {
  key: 16,
  class: "col-12 q-pb-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _ctx.showDialog,
    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.showDialog) = $event)),
    persistent: "",
    "full-height": "",
    position: "right",
    maximized: "",
    "full-width": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "card q-pa-none" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row justify-between items-center q-pa-32" }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_q_icon, {
                name: "close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                size: "20px",
                class: "cursor-pointer"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { className: "q-pt-none q-form q-px-32" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_ctx.hideForOffers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('offer'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.offerId,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.offerId) = $event)),
                        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeFilters('offerId', _ctx.filters.offerId))),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.offers,
                        onFilter: _ctx.getOffers,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["label", "modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hideForCampaigns && _ctx.hideForOffers && _ctx.hideForPostbacks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('labels'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.trafficProperty,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.trafficProperty) = $event)),
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (
                _ctx.onChangeFilters('trafficProperty', _ctx.filters.trafficProperty)
              )),
                        onFilter: _ctx.getTrafficProperties,
                        outlined: "",
                        "use-input": "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.trafficProperties
                      }, null, 8, ["label", "modelValue", "onFilter", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hideForCampaigns && _ctx.hideForOffers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('campaign'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.campaignId,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.campaignId) = $event)),
                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onChangeFilters('campaignId', _ctx.filters.campaignId))),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.campaigns,
                        onFilter: _ctx.getCampaigns,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["label", "modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForStatistics &&
                _ctx.hideForConversions &&
                _ctx.hideForCampaigns &&
                _ctx.hideForOffers
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('event'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.eventType,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.eventType) = $event)),
                        onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onChangeFilters('eventType', _ctx.filters.eventType))),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.postbackEventTypes,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["label", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hideForPostbacks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('geos'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.geoId,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.geoId) = $event)),
                        onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeFilters('geoId', _ctx.filters.geoId))),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.geos,
                        onFilter: _ctx.getGeos,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["label", "modelValue", "options", "onFilter"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForStatistics &&
                _ctx.hideForConversions &&
                _ctx.hideForCampaigns &&
                _ctx.hideForPostbacks
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('reward_type'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.rewardType,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.rewardType) = $event)),
                        onBlur: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onChangeFilters('rewardType', _ctx.filters.rewardType))),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.rewardTypes,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["label", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForConversions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('reward_type'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.rewardType,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.filters.rewardType) = $event)),
                        onBlur: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onChangeFilters('rewardType', _ctx.filters.rewardType))),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.rewardTypesWithReg,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["label", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_q_select, {
                        label: "Устройства",
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.markupType,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.filters.markupType) = $event)),
                        onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onChangeFilters('markupType', _ctx.filters.markupType))),
                        outlined: "",
                        disable: true,
                        class: "col-4 q-mb-sm",
                        options: _ctx.markupTypes,
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForOffers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('traffic_source'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.trafficSourceName,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.filters.trafficSourceName) = $event)),
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (
                _ctx.onChangeFilters('trafficSourceName', _ctx.filters.trafficSourceName)
              )),
                        onFilter: _cache[19] || (_cache[19] = (value, updateFn) => _ctx.getTrafficSources(value, updateFn)),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.trafficSourceNames
                      }, null, 8, ["label", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hideForCampaigns && _ctx.hideForOffers && _ctx.hideForPostbacks)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('landings'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.landingId,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.filters.landingId) = $event)),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.landings,
                        onBlur: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onChangeFilters('landingId', _ctx.filters.landingId))),
                        onFilter: _cache[22] || (_cache[22] = (value, updateFn) => _ctx.getLandings(value, updateFn, true)),
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["label", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForCampaigns &&
                _ctx.hideForOffers &&
                _ctx.hideForPostbacks &&
                _ctx.hideForConversions &&
                _ctx.hideForStatistics
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_q_select, {
                        label: "Прелендинги",
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.preLandingId,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.filters.preLandingId) = $event)),
                        outlined: "",
                        class: "col-4 q-mb-sm",
                        options: _ctx.preLandings,
                        onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.onChangeFilters('preLandingId', _ctx.filters.preLandingId))),
                        onFilter: _cache[25] || (_cache[25] = (value, updateFn) => _ctx.getLandings(value, updateFn, false)),
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  (
                _ctx.hideForCampaigns &&
                  _ctx.hideForOffers &&
                  _ctx.hideForPostbacks &&
                  _ctx.hideForConversions
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_q_select, {
                          label: "Sub 1",
                          "stack-label": "",
                          dense: "",
                          modelValue: _ctx.filters.sid1,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.filters.sid1) = $event)),
                          outlined: "",
                          class: "q-mb-sm",
                          options: _ctx.sids1,
                          onBlur: _cache[27] || (_cache[27] = ($event: any) => (_ctx.onChangeFilters('sid1', _ctx.filters.sid1))),
                          onFilter: _cache[28] || (_cache[28] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids1')),
                          "option-value": "id",
                          "option-label": "value",
                          "emit-value": "",
                          "map-options": "",
                          "use-input": ""
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true),
                  (
                _ctx.hideForCampaigns &&
                  _ctx.hideForOffers &&
                  _ctx.hideForPostbacks &&
                  _ctx.hideForConversions
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createVNode(_component_q_select, {
                          label: "Sub 2",
                          "stack-label": "",
                          dense: "",
                          modelValue: _ctx.filters.sid2,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.filters.sid2) = $event)),
                          outlined: "",
                          class: "q-mb-sm",
                          options: _ctx.sids2,
                          onBlur: _cache[30] || (_cache[30] = ($event: any) => (_ctx.onChangeFilters('sid2', _ctx.filters.sid2))),
                          onFilter: _cache[31] || (_cache[31] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids2')),
                          "option-value": "id",
                          "option-label": "value",
                          "emit-value": "",
                          "map-options": "",
                          "use-input": ""
                        }, null, 8, ["modelValue", "options"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (
              _ctx.hideForCampaigns &&
                _ctx.hideForOffers &&
                _ctx.hideForPostbacks &&
                _ctx.hideForConversions
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_q_select, {
                        label: "Sub 3",
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.sid3,
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.filters.sid3) = $event)),
                        outlined: "",
                        class: "q-mb-sm",
                        options: _ctx.sids3,
                        onBlur: _cache[33] || (_cache[33] = ($event: any) => (_ctx.onChangeFilters('sid3', _ctx.filters.sid3))),
                        onFilter: _cache[34] || (_cache[34] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids3')),
                        "option-value": "id",
                        "option-label": "value",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForCampaigns &&
                _ctx.hideForOffers &&
                _ctx.hideForPostbacks &&
                _ctx.hideForConversions
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_q_select, {
                        label: "Sub 4",
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.sid4,
                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.filters.sid4) = $event)),
                        outlined: "",
                        class: "q-mb-sm",
                        options: _ctx.sids4,
                        onBlur: _cache[36] || (_cache[36] = ($event: any) => (_ctx.onChangeFilters('sid4', _ctx.filters.sid4))),
                        onFilter: _cache[37] || (_cache[37] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids4')),
                        "option-value": "id",
                        "option-label": "value",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForCampaigns &&
                _ctx.hideForOffers &&
                _ctx.hideForPostbacks &&
                _ctx.hideForConversions
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createVNode(_component_q_select, {
                        label: "Sub 5",
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.sid5,
                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.filters.sid5) = $event)),
                        outlined: "",
                        class: "q-mb-sm",
                        options: _ctx.sids5,
                        onBlur: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onChangeFilters('sid5', _ctx.filters.sid5))),
                        onFilter: _cache[40] || (_cache[40] = (value, updateFn) => _ctx.getSids(value, updateFn, 'sids5')),
                        "option-value": "id",
                        "option-label": "value",
                        "emit-value": "",
                        "map-options": "",
                        "use-input": ""
                      }, null, 8, ["modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (
              _ctx.hideForConversions &&
                _ctx.hideForCampaigns &&
                _ctx.hideForOffers &&
                _ctx.hideForPostbacks
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createVNode(_component_q_select, {
                        label: _ctx.$t('groupBy'),
                        "stack-label": "",
                        dense: "",
                        modelValue: _ctx.filters.groupBy,
                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.filters.groupBy) = $event)),
                        outlined: "",
                        onBlur: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onChangeFilters('groupBy', _ctx.filters.groupBy))),
                        class: "q-mb-sm",
                        options: _ctx.groupByOptions(),
                        "option-value": "id",
                        "option-label": "name",
                        "emit-value": "",
                        "map-options": ""
                      }, null, 8, ["label", "modelValue", "options"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.hideForOffers)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createVNode(_component_DatePicker, {
                        onChangeDate: _ctx.onChangeDate,
                        from: _ctx.filters.dateFrom,
                        to: _ctx.filters.dateTo,
                        id: "1"
                      }, null, 8, ["onChangeDate", "from", "to"])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.hideForStatistics)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_q_toggle, {
                        onChange: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onChangeFilters('factualStats', _ctx.filters.factualStats))),
                        modelValue: _ctx.filters.factualStats,
                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.filters.factualStats) = $event)),
                        color: "green",
                        label: _ctx.$t('fact_stats')
                      }, null, 8, ["modelValue", "label"]),
                      _createVNode(_component_q_tooltip, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('fact_stats_tooltip')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "center",
            class: "flex column text-primary q-px-32"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                disable: _ctx.loading,
                loading: _ctx.loading,
                "no-caps": "",
                unelevated: "",
                class: "full-width q-btn__main-size",
                color: "primary",
                label: _ctx.$t('add'),
                onClick: _ctx.addFilters
              }, null, 8, ["disable", "loading", "label", "onClick"]),
              _createVNode(_component_q_btn, {
                "no-caps": "",
                flat: "",
                class: "reset-btn q-mt-md",
                label: "Скинуть",
                onClick: _ctx.resetFilters
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}